function appConfigAuth($httpProvider) {
    'ngInject';

    // Emit oauth:error on any 401 so auth.run.js can attempt a token refresh.
    // The backend returns {"code":401,"message":"Unauthorized"} for expired JWTs
    // (not the OAuth2 {"error":"invalid_token"} format), so we match on status only.
    function authInterceptor($q, $rootScope) {
        'ngInject';
        return {
            responseError: function(rejection) {
                if (401 === rejection.status) {
                    $rootScope.$emit('oauth:error', rejection);
                }
                return $q.reject(rejection);
            }
        };
    }
    $httpProvider.interceptors.push(authInterceptor);
}

export default appConfigAuth;


// WEBPACK FOOTER //
// ./client/app/app.config.auth.js